import { useSetupApp } from 'components/Layouts/hooks/useSetupApp';
import { useAuth } from 'components/providers/AuthProvider';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const ProtectedLayout = () => {
  const { loading } = useSetupApp();
  const location = useLocation();
  const { session } = useAuth();

  if (loading) return null;

  // The user is not logged in
  if (!session) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  // Redirect DDT users to /direct
  if (!session.user.isStaff && session.user.ddtId) {
    // TODO: when ddt-dashboard is ready uncomment this
    return (window.location.href = '/ddt-dashboard/');
    // return <Navigate to="/direct/dashboard" />;
  }

  return <Outlet />;
};
